export function formatDescription(description?: string) {
    return JSON.stringify(
        !description
            ? []
            : [{ type: 'p', children: [{ text: description || '' }] }]
    );
}
